import { __awaiter, __extends, __generator } from "tslib";
export var DEFAULT_ZIP_POLL_INTERVAL_MS = 1000;
export var DEFAULT_ZIP_POLL_MAX_MS = 15 * 60 * 1000;
var ZipJobCancelledError = /** @class */ (function (_super) {
    __extends(ZipJobCancelledError, _super);
    function ZipJobCancelledError(message) {
        if (message === void 0) { message = 'Zip preparation cancelled.'; }
        var _this = _super.call(this, message) || this;
        _this.cancelled = true;
        _this.name = 'ZipJobCancelledError';
        return _this;
    }
    return ZipJobCancelledError;
}(Error));
export { ZipJobCancelledError };
export function isZipJobCancelled(error) {
    if (!error || typeof error !== 'object') {
        return false;
    }
    var err = error;
    return err.cancelled === true || err.message === 'Zip preparation cancelled.';
}
function throwIfCancelled(isCancelled) {
    if (isCancelled && isCancelled()) {
        throw new ZipJobCancelledError();
    }
}
function sleep(ms, isCancelled) {
    return new Promise(function (resolve, reject) {
        var interval;
        var timer = window.setTimeout(function () {
            if (interval) {
                window.clearInterval(interval);
            }
            try {
                throwIfCancelled(isCancelled);
                resolve();
            }
            catch (error) {
                reject(error);
            }
        }, ms);
        if (isCancelled) {
            interval = window.setInterval(function () {
                if (isCancelled()) {
                    window.clearTimeout(timer);
                    if (interval) {
                        window.clearInterval(interval);
                    }
                    reject(new ZipJobCancelledError());
                }
            }, 100);
        }
    });
}
function formatProgressMessage(status) {
    var pct = typeof status.progressPercent === 'number'
        ? " (".concat(status.progressPercent, "%)")
        : '';
    var msg = status.message || 'Preparing zip...';
    return msg + pct;
}
function resolveSyncDownloadUrl(initial) {
    return initial.downloadUrl || initial.location || null;
}
export function waitForAsyncZipJob(initial, config) {
    return __awaiter(this, void 0, void 0, function () {
        var syncUrl, jobId, pollIntervalMs, pollMaxMs, isCancelled, deadline, status_1, err;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!initial) {
                        return [2 /*return*/, null];
                    }
                    syncUrl = resolveSyncDownloadUrl(initial);
                    if (!initial.async || !initial.jobId) {
                        if (!syncUrl) {
                            return [2 /*return*/, null];
                        }
                        return [2 /*return*/, {
                                downloadUrl: syncUrl,
                                message: initial.message,
                                added: initial.added,
                                failed: initial.failed,
                                errors: initial.errors,
                            }];
                    }
                    jobId = initial.jobId;
                    pollIntervalMs = config.pollIntervalMs || DEFAULT_ZIP_POLL_INTERVAL_MS;
                    pollMaxMs = config.pollMaxMs || DEFAULT_ZIP_POLL_MAX_MS;
                    isCancelled = config.pollOptions && config.pollOptions.isCancelled;
                    deadline = Date.now() + pollMaxMs;
                    if (config.onJobStarted) {
                        config.onJobStarted(jobId);
                    }
                    if (config.pollOptions && config.pollOptions.onJobStarted) {
                        config.pollOptions.onJobStarted(jobId);
                    }
                    if (config.onProgress) {
                        config.onProgress(initial.message || 'Preparing zip...');
                    }
                    _a.label = 1;
                case 1:
                    if (!(Date.now() < deadline)) return [3 /*break*/, 4];
                    throwIfCancelled(isCancelled);
                    return [4 /*yield*/, config.pollJob(jobId)];
                case 2:
                    status_1 = _a.sent();
                    if (config.onProgress) {
                        config.onProgress(formatProgressMessage(status_1));
                    }
                    if (status_1.state === 'Ready' && status_1.downloadUrl) {
                        return [2 /*return*/, {
                                downloadUrl: status_1.downloadUrl,
                                message: status_1.message || 'Ready for download',
                                added: status_1.added,
                                failed: status_1.failed,
                                errors: status_1.errors,
                            }];
                    }
                    if (status_1.state === 'Failed') {
                        err = new Error(status_1.message || 'Zip job failed');
                        err.response = { data: status_1 };
                        throw err;
                    }
                    return [4 /*yield*/, sleep(pollIntervalMs, isCancelled)];
                case 3:
                    _a.sent();
                    return [3 /*break*/, 1];
                case 4: throw new Error('Zip preparation timed out.');
            }
        });
    });
}
export function triggerFileDownload(downloadUrl) {
    var link = document.createElement('a');
    link.href = downloadUrl;
    link.style.display = 'none';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}
export function formatZipErrorMessage(error, fallback) {
    if (fallback === void 0) { fallback = 'Download could not be prepared.'; }
    var msg = fallback;
    var err = error;
    if (err.message && err.message !== 'Zip job failed') {
        msg += ' ' + err.message;
    }
    var responseData = err.response && err.response.data;
    if (responseData) {
        if (responseData.error) {
            msg += ' ' + responseData.error;
        }
        else if (responseData.detail) {
            msg += ' ' + responseData.detail;
        }
        else if (responseData.message) {
            msg += ' ' + responseData.message;
        }
    }
    return msg;
}
//# sourceMappingURL=asyncZipJob.js.map